import { render, staticRenderFns } from "./IconFlagStart.vue?vue&type=template&id=0afbd4c5"
import script from "./IconFlagStart.vue?vue&type=script&lang=js"
export * from "./IconFlagStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports